import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const Label = props => {
  const { id, required, style } = props;
  const defaultStyles = {
    color: 'var(--owner-text)',
    display: 'inline-block',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px',
    paddingRight: '20px',
    width: '265px',
  };
  return (
    <label style={{ ...defaultStyles, ...style }} htmlFor={id}>
      <FormattedMessage id={id} />
      { required && <span style={{ color: 'var(--owner-warning)' }}>*</span> }
    </label>
  );
};

Label.propTypes = {
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  style: PropTypes.object,
};
Label.defaultProps = {
  required: false,
  style: {},
};

export default Label;
